export default __webpack_public_path__ + "static/media/Gerenciar Empresa (Real Size).cfbc929f.svg";